// skills/woodcutting/woodcuttingData.js
// Woodcutting trees and configuration

export const TREES = {
    COMMON_TIMBER: {
        id: 'common_timber_tree',
        name: 'Common Timber Tree',
        level: 1,
        xp: 25,
        baseTime: 3000,
        drops: [
            { itemId: 'common_timber', weight: 1, quantity: 1 }
        ],
        color: '#8b4513',
        sprite: { sheet: 'assets/icons/woodcutting/common_timber_tree.png', x: 0, y: 0, width: 64, height: 64 }
    },
    IRONWOOD: {
        id: 'ironwood_tree',
        name: 'Ironwood Tree',
        level: 15,
        xp: 37.5,
        baseTime: 4000,
        drops: [
            { itemId: 'ironwood_logs', weight: 1, quantity: 1 }
        ],
        color: '#a0522d',
        sprite: { sheet: 'assets/icons/woodcutting/ironwood_tree.png', x: 0, y: 0, width: 64, height: 64 }
    },
    SOFTBARK: {
        id: 'softbark_tree',
        name: 'Softbark Tree',
        level: 30,
        xp: 67.5,
        baseTime: 5000,
        drops: [
            { itemId: 'softbark_logs', weight: 1, quantity: 1 }
        ],
        color: '#9acd32',
        sprite: { sheet: 'assets/icons/woodcutting/softbark_tree.png', x: 0, y: 0, width: 64, height: 64 }
    },
    GOLDLEAF: {
        id: 'goldleaf_tree',
        name: 'Goldleaf Tree',
        level: 45,
        xp: 100,
        baseTime: 6000,
        drops: [
            { itemId: 'goldleaf_logs', weight: 1, quantity: 1 }
        ],
        color: '#ff8c00',
        sprite: { sheet: 'assets/icons/woodcutting/goldleaf_tree.png', x: 0, y: 0, width: 64, height: 64 }
    },
    REDGRAIN: {
        id: 'redgrain_tree',
        name: 'Redgrain Tree',
        level: 60,
        xp: 140,
        baseTime: 7000,
        drops: [
            { itemId: 'redgrain_logs', weight: 1, quantity: 1 }
        ],
        color: '#d2691e',
        sprite: { sheet: 'assets/icons/woodcutting/redgrain_tree.png', x: 0, y: 0, width: 64, height: 64 }
    },
    GRAVEWOOD: {
        id: 'gravewood_tree',
        name: 'Gravewood Tree',
        level: 75,
        xp: 200,
        baseTime: 9000,
        drops: [
            { itemId: 'gravewood_logs', weight: 1, quantity: 1 }
        ],
        color: '#228b22',
        sprite: { sheet: 'assets/icons/woodcutting/gravewood_tree.png', x: 0, y: 0, width: 64, height: 64 }
    },
    ARCANEWOOD: {
        id: 'arcanewood_tree',
        name: 'Arcanewood Tree',
        level: 90,
        xp: 300,
        baseTime: 12000,
        drops: [
            { itemId: 'arcanewood_logs', weight: 1, quantity: 1 }
        ],
        color: '#9370db',
        sprite: { sheet: 'assets/icons/woodcutting/arcanewood_tree.png', x: 0, y: 0, width: 64, height: 64 }
    }
};

// Woodcutting tools/axes
export const AXES = {
    COMMON: {
        id: 'common_axe',
        name: 'Common Axe',
        level: 1,
        speedMultiplier: 1.0,
        price: 0 // Starting tool
    },
    BLACKIRON: {
        id: 'blackiron_axe',
        name: 'Blackiron Axe',
        level: 10,
        speedMultiplier: 1.2,
        price: 1000
    },
    PALE_SHARD: {
        id: 'pale_shard_axe',
        name: 'Pale Shard Axe',
        level: 20,
        speedMultiplier: 1.4,
        price: 5000
    },
    SKYIRON: {
        id: 'skyiron_axe',
        name: 'Skyiron Axe',
        level: 40,
        speedMultiplier: 1.6,
        price: 25000
    },
    VERDANT: {
        id: 'verdant_axe',
        name: 'Verdant Axe',
        level: 60,
        speedMultiplier: 1.8,
        price: 100000
    },
    VOIDSTEEL: {
        id: 'voidsteel_axe',
        name: 'Voidsteel Axe',
        level: 80,
        speedMultiplier: 2.0,
        price: 250000
    }
};

export default {
    TREES,
    AXES
};
